import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import './RoomDialog.css'
import { useDispatch } from 'react-redux';
import { updateRoom } from '../../../../store/RoomMenu/RoomMenuThunks.js';
import { UPDATE_ROOMS } from '../../../../store/RoomMenu/RoomMenuSlice.js';
import { useTranslation } from 'react-i18next';

export default function RoomDialog(
  {
    handleClose,
    roomLabel,
    roomId ,
    setAnchorPosition
  }) {
 const dispatch = useDispatch();
 const { t } = useTranslation();

const [inputValue, setInputValue] = useState(roomLabel);

  const handleSave = async () => {
    if (!inputValue.trim()) return;
    dispatch(updateRoom({body :{roomId, label: inputValue}})).unwrap();
    dispatch(UPDATE_ROOMS());
    dispatch(setAnchorPosition(null));
    handleClose();
  };

  const handleInputChange = (event) => {
    const val = event.target.value;
    if (val.length <= 60) setInputValue(val);
    else setInputValue(val.substring(0, 60));
  };
  return (
    
    <Dialog
      open={true} 
      onClose={handleClose}
      PaperProps={{
        style: {
          width: "56.25rem",
          height: "15.625rem",
        },
      }}
    >
      <DialogTitle>
        <div class="title-dialog">
          <h2>
            {t("update_room_name")}
          </h2>
          <span onClick={handleClose} class="material-symbols-outlined cursor-pointer">close</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <TextField
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: 'var(--peoplmap-primary)', // couleur de la bordure au focus
              },
            },
            '& label.Mui-focused': {
              color: 'var(--peoplmap-primary)', // couleur du label au focus
            },
          }}
          autoFocus
          margin="dense"
          label={`${t("room_name")} ${roomLabel.length}/60`}
          type="text"
          fullWidth
          value={inputValue} 
          onChange={handleInputChange}
        />
      </DialogContent>
      <DialogActions sx={{ padding: '0 2rem 2rem' }}>
        <Button onClick={handleClose} sx={{
          backgroundColor: "#ffffff",
          color: "var(--peoplmap-primary)",
          fontSize: "0.875rem",
          textTransform: "none",
          padding: "0.6875rem 1.375rem",
          borderRadius: "0.5rem"
        }}>
          {t("cancel")}
        </Button>
        <Button onClick={handleSave} disabled={!roomLabel} sx={{
          backgroundColor: "var(--peoplmap-primary)",
          color: "#171717",
          fontSize: "0.875rem",
          textTransform: "none",
          padding: "0.6875rem 1.375rem",
          borderRadius: "0.5rem"

        }}>
          {t("save")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
